var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.084,
    height: 52.267,
    viewBox: "0 0 50.084 52.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10109",
    "data-name": "Grupo 10109",
    transform: "translate(-356.25 -401.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9174",
    "data-name": "Trazado 9174",
    d: "M373.286,446.675H362.367A4.38,4.38,0,0,1,358,442.307v-34.94A4.38,4.38,0,0,1,362.367,403h19.654l10.919,10.919v4.171",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#5900b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_261",
    "data-name": "Elipse 261",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(377 425.043)",
    fill: "none",
    stroke: "#5900b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_48",
    "data-name": "L\\xEDnea 48",
    x1: 7.556,
    y1: 7.556,
    transform: "translate(396.303 443.487)",
    fill: "none",
    stroke: "#5900b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_49",
    "data-name": "L\\xEDnea 49",
    x2: 13,
    transform: "translate(367 414.043)",
    fill: "none",
    stroke: "#5900b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_50",
    "data-name": "L\\xEDnea 50",
    x2: 6,
    transform: "translate(367 425.043)",
    fill: "none",
    stroke: "#5900b4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.c1f36cd1.svg";
export { ForwardRef as ReactComponent };